import { render } from "./IframeModal.vue?vue&type=template&id=4b5deb0b"
import script from "./IframeModal.vue?vue&type=script&lang=js"
export * from "./IframeModal.vue?vue&type=script&lang=js"

import "./IframeModal.vue?vue&type=style&index=0&id=4b5deb0b&lang=css"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__